import { FC, ReactNode, SyntheticEvent } from 'react';
import CustomTab from '../../pages/CustomTab/CustomTab';
import './LiveClassTabs.scss';

export const LIVE_CLASS_TAB_LABELS = ['Live Class', 'Attendance'];
export const LIVE_CLASS_TAB = 0;
export const ATTENDANCE_TAB = 1;

interface LiveClassTabsProps {
  activeTab: number;
  onChangeTab: (tabIndex: number) => void;
  /** Tab-specific actions (e.g. Create button, date filter) rendered at the right end of the tab bar. */
  actions?: ReactNode;
}

const LiveClassTabs: FC<LiveClassTabsProps> = ({ activeTab, onChangeTab, actions }) => {
  const handleChangeTab = (_e: SyntheticEvent, index: number) => onChangeTab(index);

  return (
    <div className='liveClassTabContainer'>
      <CustomTab activeTab={activeTab} handleChangeTab={handleChangeTab} labels={LIVE_CLASS_TAB_LABELS} />
      {actions && <div className='liveClassTabActions'>{actions}</div>}
    </div>
  );
};

export default LiveClassTabs;
